import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared';
import { CapitalSocialFormControlTextComponent } from './capital-social-form-control-text.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        CapitalSocialFormControlTextComponent
    ],
    exports: [
        CapitalSocialFormControlTextComponent
    ]
})
export class CapitalSocialFormControlTextModule { }
